// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ppGV9","toggle":"styles_toggle__2nThl","preview":"styles_preview__KtM7t"};